import { useEffect, useState } from "react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function SplashScreen() {
  const [fase, setFase] = useState(() => (isStandalone() && !sessionStorage.getItem("gromapp_splash") ? "on" : "off"));

  useEffect(() => {
    if (fase !== "on") return undefined;
    sessionStorage.setItem("gromapp_splash", "1");
    const t1 = setTimeout(() => setFase("fade"), 1500);
    const t2 = setTimeout(() => setFase("off"), 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fase === "off") return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#0B1F3A] text-white flex flex-col items-center justify-center transition-opacity duration-500 ${fase === "fade" ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      onClick={() => setFase("off")}
      data-testid="splash-screen"
    >
      <img src="/icon-192.png" alt="GromApp" className="h-28 w-28 rounded-2xl shadow-2xl splash-pop" />
      <div className="mt-6 font-heading font-extrabold text-3xl tracking-tight splash-rise">
        Grom<span className="text-sky-200">App</span> <span className="font-normal text-slate-300">Studio</span>
      </div>
      <div className="mt-3 text-sm text-slate-300 splash-rise" style={{ animationDelay: "180ms" }}>
        Lo strumento dei geometri, <span className="text-sky-200">da 2000 anni.</span>
      </div>
      <div className="absolute bottom-10 text-[10px] font-mono uppercase tracking-[0.25em] text-slate-500">Gestionale per studi tecnici</div>
    </div>
  );
}
